import PropTypes from 'prop-types';
import SubscriptionIcon from '../icons/Subscription';
import PersonIcon from '@material-ui/icons/Person';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PageLayout from '../PageLayout';
import GS from '../../grafsync/grafsync';
import UserData from '../mydetails/UserData';
import SubscriptionManager from '../subscription/SubscriptionManager';

const baseURL = "/account";

class AccountManager extends Component {

  render() {

    const { user } = this.props;

    let options = [
      {
        name: "My Details",
        url: 'mydetails',
        icon: <PersonIcon />
      }
    ];

    const isAdmin = user.systemAdmin || user.superAdmin;

    if (!isAdmin) {
      options.push({
        name: "Subscriptions",
        url: 'subscriptions',
        icon: <SubscriptionIcon />
      });
    }

    const pageCrumb = <Switch>
      {!isAdmin && <Route path={baseURL + "/subscriptions"} render={() => <span>Subscriptions</span>} />}
      <Route path={baseURL + "/mydetails"} render={() => <span>My Details</span>} />
    </Switch>;

    return (
      <PageLayout
        title="Account"
        baseURL="/account"
        options={options}
        graph={GS.getActiveSubscription()}
        layoutTitle={function () { return (pageCrumb); }}
        breadcrumb={{
          baseURL,
          title: "Account",
          static: pageCrumb
        }}>
        <Switch>
          {!isAdmin && <Route path={baseURL + "/subscriptions"} render={(props) => <SubscriptionManager {...props} {...this.props} />} />}
          <Route path={baseURL + "/mydetails"} render={(props) => <UserData {...props} {...this.props} />} />
        </Switch>
      </PageLayout>
    );
  }
}

AccountManager.propTypes = {
  user: PropTypes.object
};

export default AccountManager;